export default __webpack_public_path__ + "static/media/cuet-faq.92b59141.png";